import React from "react";
import * as dc from "dc";
import * as d3 from 'd3';
import {timeFormat} from "d3-time-format";
import { RangeTemplate } from "./rangeTemplate";

const barChartFunc = (divRef, ndx, type, rangeChart) => {
  let name
  const myChart = dc.lineChart(divRef);
  let month;
  const dateFormat = d3.timeFormat("%Y-%m-%d");
  const parseDate = d3.utcParse("%Y-%m-%dT%H:%M:%S%Z");
  const parseTime = d3.timeParse(dateFormat);

  const dimension = ndx.dimension(function (d) {
       return d3.timeDay(d.dincoming);
      //return d3.timeDay(d.dreserved);
  });
  const group = dimension.group().reduce(
    function(p, v) { // add
      ++p.count;
      if(p.count > 0) {
        p.total += parseFloat(v.wait_time);
        p.avg = parseFloat(p.total/p.count);
        p.tot_conversation_time += parseFloat(v.conversation_time);
        p.avg_conversation_time = parseFloat(p.tot_conversation_time/p.count);
      }
      else {
        p.avg = 0;
        p.total = 0;
        p.tot_conversation_time = 0;
        p.avg_conversation_time = 0;
      }
      return p;
    },
    function(p, v) { // remove
      --p.count;
      if(p.count > 0) {
        p.total -= Math.floor(parseFloat(v.wait_time));
        p.avg = Math.floor(parseFloat(100*p.total/p.count))/100 ;
        p.tot_conversation_time -=  Math.floor(parseFloat(v.conversation_time));
        p.avg_conversation_time =  Math.floor(parseFloat(100*p.tot_conversation_time/p.count))/100;
      }
      else {
        p.avg = 0;
        p.total = 0;
        p.tot_conversation_time = 0;
        p.avg_conversation_time = 0;
      }
      return p;
    },
    function() { // init
        return {count: 0, total: 0, avg: 0, tot_conversation_time: 0, avg_conversation_time: 0};
    }
  );

  const minDate = dimension.bottom(1)[0].incoming_time;
  const maxDate = dimension.top(1)[0].incoming_time;

  console.log(minDate);
  console.log(maxDate);

  function remove_empty_bins(source_group) {
    return {
      all: function () {
        return source_group.all().filter(function(d) {
            //return Math.abs(d.value) > 0.00001; // if using floating-point numbers
            return d.value.count !== 0; // if integers only
        });
      }
    };
  }

  const calc_ticks = (chart) => {
     // if(type != 'series')
    //    chart.xAxis().tickFormat(d3.timeFormat("%b-%y"));
    //chart.xAxis().tickFormat(d3.timeFormat("%d-%b-%y"));
    nonzero_min(chart);
    //calcy_ticks(chart);
    let minDateFiltered, maxDateFiltered;
    // console.log('type '+type)
    //if(type === 'series') {
    //   chart.brushOn(false);
    //   chart.rangeChart(rangeChart);
    //   chart.rescale();


      // chart.on('filtered', function(chart) {
      //      const filters = chart.filters();
      //     if(filters.length) {
      //         const range = filters[0];
              //console.log('range:', range[0], range[1]);

              // minDateFiltered = new Date(range[0])//.toString();
              // maxDateFiltered = new Date(range[1])//.toString();
              //console.log('range:',minDateFiltered,maxDateFiltered);
              // chart.xAxis().tickFormat(d3.timeFormat("%d-%b-%y"));
              //chart.x(d3.scaleTime().domain([minDateFiltered, maxDateFiltered]));
    //       }
    //       else
    //           console.log('no filters');
    //           chart.xAxis().tickFormat(d3.timeFormat("%b-%y"));
    //           //chart.x(d3.scaleTime().domain([minDate,maxDate]));
    //   });
    // }
  }

  const nonzero_min = (chart) => {
    dc.override(chart, 'yAxisMin', function () {
         var min = d3.min(chart.data(), function (layer) {
             return d3.min(layer.values, function (p) {
                 return p.y + p.y0;
             });
         });
         return dc.utils.subtract(min, chart.yAxisPadding());
    });
    return chart;
  }

  const calcy_ticks = (chart) => {
    dc.override(chart, 'yAxis', function (){
      if(type === 'series') {
        return chart.yAxis.ticks(6);
      }
      return chart.yAxis.ticks(2);
    });
    return chart;
  }


  myChart
  .dimension(dimension)
  .group(remove_empty_bins(group))
  .valueAccessor(function (p) {
     return p.value.count ;
   })
  .curve(d3.curveMonotoneX)
  //.renderArea(true)
  //.renderDataPoints(true)
  //
  .x(d3.scaleTime().domain([dimension.bottom(1)[0].incoming_time, dimension.top(1)[0].incoming_time ]))
  //.x(d3.scaleTime().domain(['3/15/2018','6/18/2019']))
  //.y(d3.scaleLinear().domain([150,250]))
  .xUnits(d3.timeDays)
  .brushOn(true)
  .elasticX(true)
  .elasticY(true)
  .height(function(){
    if(type === 'series') return 200;
    return 70;
  })
  .round(dc.round.floor)
  .margins({ top: 5, right: 15, bottom: 25, left: 50 })
  .title(function(d) {
    const dFormat = d3.timeFormat("%m/%d/%Y");
    const vFormat = d3.format(".0f");
    const tFormat = d3.format("4n");
    return "Date:   " + dFormat(d.key) + "\n" +
           "Value:  " + vFormat(myChart.valueAccessor()(d)) + "\n" })

  .yAxis().ticks(3)
  myChart.on('preRender', calc_ticks)
    .on('preRedraw', calc_ticks)

  if(type === 'series') {
    myChart.brushOn(false)
    .rangeChart(rangeChart)
    .renderDataPoints(true)
  }

  return myChart
}

export const RangeChart = props => (
  <RangeTemplate chartFunction={barChartFunc} />
)
